import { mapFilters } from '../../shared/helpers';

export function index({filters, page, all = 0, extraIncludes = []})
{
    let sort = filters.active === 0 ? '-archived' : '-is_spontaneous,sequence';
    extraIncludes = extraIncludes.join(',');

    return axios.get(route('api.manage.companies.jobs') + `?include=stages,subscriptions,companyLocation,responsibleUser.companyUsers.role,requestedAndActiveBoosters.booster,activeCampaignsCount,newApplicationsCount,${extraIncludes}`, {
        params: {
            ...mapFilters(filters),
            sort: sort,
            page,
            fetch: (all ? 'all' : ''),
        }
    }).then((response) => {
        return response.data;
    });
}

export function parameters()
{
    return axios.get(route('api.manage.companies.jobParameters'))
        .then(response => response.data);
}

export function filterParameters()
{
    return axios.get(route('api.manage.companies.jobParameters.filter'))
        .then(response => response.data);
}

export function find(id)
{
    return axios.get(route('api.manage.jobs.show', { jobId: id }) + '?include=tags,stages,filters,subscriptions,subscriptions.user,attachments,internalNoteAttachments,vdabJob,campaigns.channels,jobChannels')
        .then(response => {
            return response.data;
        });
}

export function filters()
{
    return axios.get(route('api.manage.companies.filters') + '?limit=99')
        .then(response => response.data);
}

export function filtersWithoutGroup()
{
    return axios.get(route('api.manage.companies.filters.without-group') + '?limit=99')
        .then(response => response.data);
}

export function filterGroups(filters = false)
{
    return axios.get(route('api.manage.companies.filter-groups') + (filters ? '?include=filters' : ''))
        .then(response => response.data);
}

export function storeFilter(data)
{
    return axios.post(route('api.manage.companies.filters.store'), data)
        .then(response => response.data);
}

export function updateFilter(filterId, data)
{
    return axios.patch(route('api.manage.filters.update', {filterId}), data)
        .then(response => response.data);
}

export function destroyFilter(filterId)
{
    return axios.delete(route('api.manage.filters.destroy', { filterId: filterId }));
}

export function updateSort(sort) {
    return axios.patch(route('api.manage.companies.jobs.sort'), {
        data: sort
    }).then(response => {
        return response.data;
    });
}

export function updateSortSimple(sort) {
    return axios.patch(route('api.manage.companies.jobs.sort-simple'), {
        data: sort
    }).then(response => {
        return response.data;
    });
}

export function store(data) {
    return axios.post(route('api.manage.companies.jobs') + '?include=filters,stages,subscriptions', data)
        .then(response => response.data);
}

export function update(jobId, data, include = []) {
    include.push('filters');
    return axios.patch(route('api.manage.jobs.update', {jobId: jobId}) + `?include=${include.join(',')}`, data)
        .then(response => response.data);
}

export function updateResponsibleUser(jobId, data)
{
    return axios.patch(route('api.manage.jobs.update.responsible-user', { jobId: jobId }) + '?include=filters', data)
        .then(response => response.data);
}

export function archive(jobId, data)
{
    return axios.post(route('api.manage.jobs.archive', { jobId }), data)
        .then(response => response.data);
}

export function destroy(jobId)
{
    return axios.delete(route('api.manage.jobs.destroy', { jobId: jobId }));
}

export function addAttachment(jobId, data)
{
    return axios.post(route('api.manage.jobs.jobAttachments.store', {jobId}), data)
        .then(response => response.data);
}

export function updateAttachment(attachmentId, data)
{
    return axios.patch(route('api.manage.jobAttachments.update', {attachmentId}), data)
        .then(response => response.data);
}

export function deleteAttachment(attachmentId)
{
    return axios.delete(route('api.manage.jobAttachments.destroy', {attachmentId}));
}

export function duplicate(jobId, data)
{
    return axios.post(route('api.manage.jobs.duplicate', {jobId}) + '?include=stages,attachments,filters,subscriptions', data)
        .then(response => response.data);
}

export function shareJobWithInterims(jobId, data)
{
    return axios.post(route('api.manage.jobs.interimJobs.store', {jobId}), data)
        .then(response => response.data);
}

export function stats(jobId) {
    return axios.get(route('api.manage.jobs.stats', { jobId }))
        .then(response => response.data);
}

export function referrers(jobId) {
    return axios.get(route('api.manage.jobs.referrers', { jobId }))
        .then(response => response.data);
}

export function applications(jobId) {
    return axios.get(route('api.manage.jobs.applications', {jobId}))
        .then(response => response.data);
}

export function limits() {
    return axios.get(route('api.manage.companies.jobs.limits'))
        .then(response => response.data);
}

export function names(type = null) {
    return axios.get(route('api.manage.companies.jobs.names'), {
        params: {type}
    })
        .then(response => response.data);
}

export function stages(jobId) {
    return axios.get(route('api.manage.companies.jobs.stages', {jobId}))
        .then(({data}) => data)
}

export function sharedInterimEmails(jobId) {
    return axios.get(route('api.manage.companies.jobs.interim.emails', {jobId}))
        .then(({data}) => data)
}

export function outstanding() {
    return axios.get(route('api.manage.companies.jobs.outstanding'))
        .then(({data}) => data)
}

export function bulkDynamicFormFields(interimId, jobIds, data) {
    return axios.patch(route('api.manage.interims.update-bulk-dynamic-form-fields', {interimId}) + `?jobIds=${jobIds.join(',')}`, data)
        .then(({data}) => data)
}

